var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuxicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120.46 174.53",
    className: "size-7",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06,0c.93,1.5,3.47,1.96,4.79,2.62,3.51,1.74,7.02,4.15,10.46,5.23l2.18,2.18L.09,34V3.05L2.7,0h4.36Z",
    fill: "#22d3ee"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.95,0l2.62,3.05c-.08,9.3.11,18.6,0,27.9-.01.89.43,2.73-.44,3.05l-23.97-23.97,2.18-2.18c3.84-1.29,7.68-4.03,11.33-5.23l3.92-2.62h4.36Z",
    fill: "#22d3ee"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.65,15.69c1.13-.31,3.05.21,4.36,0l33.56,33.56v4.36l-34.43,33.56c-1.88.41-2.88-.52-4.36-.87L.96,54.49c-.64-1.66-1.17-3.16-.87-5.23L33.65,15.69Z",
    fill: "#22d3ee"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7,86.3c.52-.15,1.17.11,1.74,0l38.79,38.79c-.5.94.78,1.34.87,1.74.43,1.86-.54,2.89-.87,4.36l-42.28,42.28c-.94-.5-1.34.78-1.74.87-3.24.73-4.56-.84-6.54-3.05v-75.84c.77-.64,1.4-1.59,2.18-2.18.19-.14.7.14.87,0,1.48-1.17,6.17-6.74,6.97-6.97Z",
    fill: "#22d3ee"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.21,96.77v46.2L3.57,113.76c-.87-1.93-1.06-3.73-.87-6.1l17.87-17.87c2.56-.73,4.91,3.86,6.97,5.23.19.12.64-.14.87,0,1.58.94,2.81,2.17,4.79,1.74Z",
    fill: "#22d3ee"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.95,121.17c-.08-.08.09-.94-.87-2.18-1.78-2.29-11.9-11.1-12.2-12.2v-27.02c1.75-2.03,3.81-3.38,6.54-3.05l23.97,23.97c-.15,1.1.22,2.5,0,3.49-.07.31-.7.49-.87.87-.12.27.11.68,0,.87-.99,1.66-12.41,12.88-14.38,14.38-.53.4-1.57,1.48-2.18.87Z",
    fill: "#22d3ee"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuxicon);
export default __webpack_public_path__ + "static/media/fuxicon.1666ce65c5a3c3067312647775cdc770.svg";
export { ForwardRef as ReactComponent };